<template>
  <div class="pop-bonus-card text-left">
    <div class="pop-bonus-card__header">
      <p class="pop-bonus-card__text">
        <b>¡Felicidades!</b> Tu bono POP ganado durante el trimestre
        <span class="pop-bonus-card__amount"> {{ currentQuarter }} </span> es de
        <span class="pop-bonus-card__amount">{{
          formatNumber(popBonusResume?.BONOTOTAL, '$', 0)
        }}</span>
        <span> (Sin IVA).</span>
      </p>
    </div>

    <div class="pop-bonus-card__header">
      <ul class="pop-list">
        <p class="pop-bonus-card__section">
          De este monto, tienes
          <span class="pop-bonus-card__amount">
            {{ formatNumber(popBonusResume?.SALDOBONO, '$', 0) }} (sin IVA)
            disponibles
          </span>
          para canje en:
        </p>
        <li>Exhibidores</li>
        <li>Demo Exhibidores</li>
        <li>Catálogos</li>
        <li>Rotulación de Fachadas y Camiones</li>
        <li>Vallas Móviles Publicitarias</li>
        <li>Expos y Ferias</li>
        <li>Spots publicitarios</li>
      </ul>

      <div class="pop-bonus-card__section">
        <p class="pop-bonus-card__text">
          Adicionalmente, puedes utilizar hasta:
        </p>
        <p class="pop-bonus-card__text">
          <strong>30% de tu bono en Promocionales:</strong> tienes
          <strong
            >{{ formatNumber(popBonusResume?.SALDOFAMIZC, '$', 0) }} (Sin
            IVA)</strong
          >
          disponibles.
        </p>

        <p class="pop-bonus-card__text">
          <strong> 20% de tu bono en Uniformes: </strong> tienes
          <strong
            >{{ formatNumber(popBonusResume?.SALDOFAMIZB, '$', 0) }} (Sin
            IVA)</strong
          >
          disponibles.
        </p>
      </div>
      <div class="pop-bonus-card__header">
        <p class="pop-bonus-card__text">
          Tu bono estará <strong> disponible hasta el {{ validUntil }}</strong
          >.
        </p>
      </div>
    </div>
    <div class="pop-bonus-card__warning">
      <ul class="pop-bonus-card__list">
        <p class="pop-bonus-card__title">Importante:</p>
        <li>
          Para solicitar
          <strong
            >Rotulación de Camiones, Rotulación de Fachadas, Vallas Móviles
            Publicitarias, Expos y Ferias o Spots publicitarios, </strong
          >contacta a tu vendedor.
        </li>
        <li>
          Después de facturar tu pedido, recuerda ingresar a
          <strong> Movimientos de Cuenta </strong> y aplicar tu bono
          <strong>(nota de crédito)</strong> a tu factura POP.
        </li>
        <li>
          Si al facturar tu pedido excedes el importe disponible de tu bono,
          <strong> deberás pagar la diferencia.</strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import numbersFormats from '@/mixins/numbersFormats';
  import Quarter from '@/core/models/quarter';

  export default {
    name: 'PopBonusNotification',
    mixins: [numbersFormats],
    props: {
      customer: {
        type: String,
        required: true,
      },
      chnl: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        popBonusResume: null,
        validUntil: Quarter.getCurrentQuarterEndDate().endDateFormatted,
        currentQuarter: Quarter.getPreviousQuarterMonthRangeLabel(),
      };
    },
    async mounted() {
      try {
        const response = await this.getPopResume({
          customer: this.customer,
          channel: this.chnl,
        });
        this.popBonusResume = response;
        this.dialog = true;
      } catch (error) {
        this.$toast.error(
          'Ocurrió un error al cargar el resumen del bono POP disponible.'
        );
      }
    },
    methods: {
      ...mapActions('bonusCustomer', ['getPopResume']),
    },
  };
</script>

<style scoped>
  .pop-bonus-card {
    padding: 20px;
    background-color: #fff;
    font-family: inherit;
  }

  .pop-bonus-card__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    margin-top: 10px;
  }
  .pop-bonus-card__title {
    margin: 0;
    width: 100%;
    font-size: 14px;
    color: #333;
    text-align: center;
    font-weight: bold;
  }

  .pop-bonus-card__amount {
    font-weight: 700;
    color: #1a1a1a;
  }

  .pop-bonus-card__note {
    font-size: 12px;
    color: #777;
  }

  .pop-bonus-card__section {
    text-align: center;
    font-size: 13.5px;
    color: #333;
    line-height: 1.5;
    margin: 0;
  }

  .pop-bonus-card__text {
    margin: 4px 0;
    font-size: 13.5px;
    color: #333;
    line-height: 1.5;
    margin: 0;
  }

  .pop-bonus-card__text--bold {
    font-weight: 600;
  }

  .pop-bonus-card__text--normal {
    font-weight: 400;
    color: #666;
  }

  .pop-bonus-card__warning {
    margin-top: 16px;
    padding: 12px 14px;
    background-color: #fff8e6;
    border-left: 3px solid #f0b429;
    border-radius: 4px;
  }

  .pop-bonus-card__list {
    margin: 0;
    padding-left: 18px;
  }

  .pop-bonus-card__list li {
    font-size: 13px;
    color: #5c4b00;
    line-height: 1.6;
    margin-bottom: 6px;
  }

  .pop-bonus-card__list li:last-child {
    margin-bottom: 0;
  }

  .pop-bonus-card__title {
    font-size: 14px;
    color: #5c4b00;
    line-height: 1.6;
    font-weight: bold;
    margin-bottom: 6px;
    margin: 0;
    text-align: left;
  }

  .pop-list {
    list-style: none;
    font-size: 13.5px;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    margin-bottom: 6px;
  }

  .pop-list li {
    margin: 0;
    padding: 0;
    line-height: 1.4;
  }
</style>
